import React, { useEffect, useState } from "react";
import CandidateDocView from "../CandidateDocView";
import { Card, Collapse, Tooltip } from "antd";
import {
  Pending,
  ReadyForReview,
  Rejected,
  Verified,
} from "../../../components/components/StatusIndicators";
import useAxios from "../../../hooks/useAxios";
import ExperiencePopUp from "../components/ExperiencePopUp";
import ReactLoading from "react-loading";

const { Panel } = Collapse;

const DocumentForms = ({
  activeDocKey,
  isInputFieldTouched,
  disabledDueToAadhar,
  handleAlert,
  application,
  pageRefresh,
  toggleAlert,
  setActiveDocKey,
  setIsFieldTouch,
  onBlurHandler,
  aadharDetails,
  isFieldTouch,
  setToggleAlert,
  aiSettings,
  id,
}) => {
  const api = useAxios();
  const [loading, setLoading] = useState(false);
  const [formList, setFormList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [customAlert, setCustomAlert] = useState({
    show: false,
    mappingId: "",
    key: "",
  });

  const unSendProfessionalForm = async (_id) => {
    try {
      setLoading(true);
      await api.put(
        `/candidateDocuments/pullBackDocuments/${_id}`,
        {},
        { tokenType: "candidate" },
      );
      await getCandidateFormsList();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getDepartment = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "candidate",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateFormsList = async () => {
    try {
      const { data } = await api.get(`/candidateDocuments/candidate/${id}`, {
        tokenType: "candidate",
      });
      setFormList(data.candidateDocumentDetails);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await Promise.all([getCandidateFormsList(), getDepartment()]);
      } catch (err) {
        console.error(err);
      }
    };

    init();
  }, []);

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Card title="Document Forms" className={" bg-white mb-4"}>
        <Collapse
          activeKey={activeDocKey}
          onChange={(key) => {
            if (key) {
              const keyData = key.split("_");
              const id = keyData[0];
              const isFilled = keyData[1];
              const mappingId = keyData[2];
              if (
                [
                  "6561e3e4ab0e0a0fe457d8e2",
                  "65637ccf0af1107ef50c7c83",
                ].includes(id) &&
                isFilled === "1"
              ) {
                setCustomAlert({
                  ...customAlert,
                  key,
                  mappingId,
                  show: true,
                });
              } else {
                handleAlert(key);
              }
            } else {
              handleAlert(key);
            }
          }}
          style={{ position: "relative" }}
          accordion
        >
          {formList?.map((ele, index) => {
            return (
              <Panel
                disabled={disabledDueToAadhar}
                header={
                  <div>
                    <div
                      className="flex-wrap"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        // flexWrap:"wrap",
                        // paddingRight: "20px",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        {ele?.formId?.name}
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      {ele.isFilledStatus === false &&
                      ele.documentStatus === null ? (
                        <Pending />
                      ) : (
                        <>
                          {(ele.documentStatus === null ||
                            ele.documentStatus === false) &&
                          ele.isFilledStatus === true ? (
                            <ReadyForReview />
                          ) : (
                            <>
                              {ele.documentStatus ? (
                                <Verified />
                              ) : (
                                <Tooltip
                                  title={ele.rejectionReason}
                                  color={"red"}
                                >
                                  <Rejected />
                                </Tooltip>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                }
                key={`${ele?.formId?._id}_${
                  ele?.isFilledStatus || ele?.documentStatus !== null ? 0 : 1
                }_${ele?._id}`}
              >
                <CandidateDocView
                  key={activeDocKey}
                  setActiveDocKey={setActiveDocKey}
                  aadharDetails={aadharDetails}
                  candidate={application}
                  onBlurHandler={onBlurHandler}
                  isInputFieldTouched={isInputFieldTouched}
                  toggleAlert={toggleAlert}
                  setToggleAlert={setToggleAlert}
                  isFieldTouch={isFieldTouch}
                  setIsFieldTouch={setIsFieldTouch}
                  getCandidateFormsList={getCandidateFormsList}
                  pageRefresh={!pageRefresh}
                  candidateId={application?._id}
                  formData={ele}
                  reason={ele.rejectionReason}
                  approve={ele.documentStatus}
                  filled={ele.isFilledStatus}
                  rights={"candidate"}
                  aiSettings={aiSettings}
                  departments={departments}
                />
              </Panel>
            );
          })}
        </Collapse>
      </Card>
      {customAlert?.show && (
        // <CustomAlert
        //   customAlert={customAlert}
        //   setCustomAlert={setCustomAlert}
        //   unSendProfessionalForm={unSendProfessionalForm}
        //   handleAlert={handleAlert}
        // />
        <ExperiencePopUp
          customAlert={customAlert}
          setCustomAlert={setCustomAlert}
          unSendProfessionalForm={unSendProfessionalForm}
          handleAlert={handleAlert}
        />
      )}
    </>
  );
};

export default DocumentForms;
